import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';

function formatDate(str) {
  return new Date(str).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

async function fetchPosts() {
  const indexRes = await fetch(`/blog/index.json?t=${Date.now()}`);
  const slugs = await indexRes.json();
  const posts = await Promise.all(
    slugs.map(slug =>
      fetch(`/blog/${slug}.json?t=${Date.now()}`).then(r => r.json())
    )
  );
  return posts.sort((a, b) => new Date(b.date) - new Date(a.date));
}

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    fetchPosts()
      .then(setPosts)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page blog-page">
      <section className="blog-hero">
        <div className="blog-hero__blob" aria-hidden="true" />
        <div className="container animate-fade-up">
          <span className="eyebrow">PERM Systems</span>
          <h1 className="display-title">Updates &amp; Blog</h1>
          <p className="section-body">
            Product announcements, release notes, and thoughts from the team.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading && (
            <div className="blog-loading">
              <div className="blog-loading__spinner" />
              <span>Loading posts...</span>
            </div>
          )}
          {error && (
            <div className="blog-empty">
              <p>Could not load posts. Check back soon.</p>
            </div>
          )}
          {!loading && !error && posts.length === 0 && (
            <div className="blog-empty"><p>No posts yet. Check back soon.</p></div>
          )}
          {!loading && !error && posts.length > 0 && (
            <div className="blog-list">
              {posts.map(post => (
                <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-card">
                  <div className="blog-card__meta">
                    <span className="blog-card__tag" style={{ background: `${post.tagColor}18`, color: post.tagColor }}>
                      {post.tag}
                    </span>
                    <span className="blog-card__date">{formatDate(post.date)}</span>
                  </div>
                  <h2 className="blog-card__title">{post.title}</h2>
                  <p className="blog-card__excerpt">{post.excerpt}</p>
                  <span className="blog-card__read">Read post →</span>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}